import { render, staticRenderFns } from "./RxDetails.vue?vue&type=template&id=53e54c4d&scoped=true"
import script from "./RxDetails.vue?vue&type=script&lang=js"
export * from "./RxDetails.vue?vue&type=script&lang=js"
import style0 from "./RxDetails.vue?vue&type=style&index=0&id=53e54c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e54c4d",
  null
  
)

export default component.exports